import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useState } from 'react';
import { t } from '../../../../../types/translation/Translator';
import { SuperUser, SuperUserRole, superUserRoleToString } from '../../../../../types/superUser';
import ModalPane from '../../../../../VentoryUI/components/common/Modal/components/ModalPane';
import { TranslationLanguage } from '../../../../../types/translation/translation';
import { DropdownMultiSelect, DropdownSelect } from '../../../../components/Dropdown';
import { Icon } from '../../../../icons';
import { IconType } from '../../../../icons/Icon';
import { LanguageDisplayNames } from '../../../../../types/translation/localization.utils';
import { TextInput } from '../../../../components/TextInput';

interface SuperUserInfoPaneInputProps {
  superUser: SuperUser;
  footer: (input: SuperUser) => JSX.Element;
}

export default function SuperUserInfoPane({ superUser, footer }: SuperUserInfoPaneInputProps) {
  const [input, setInput] = useState<SuperUser>(new SuperUser(superUser));

  return (
    <ModalPane footer={footer(input)}>
      <div className='grid gap-4 3xl:w-1/2'>
        <TextInput
          disabled={!!input.id}
          mandatory
          value={input.email}
          label={t(TranslationKey.email).singular.label}
          placeholder={t(TranslationKey.email).singular.label}
          onChange={v => setInput(input.withEmail(v))}
        />

        <DropdownSelect
          label={t(TranslationKey.role).singular.label}
          placeholder={t(TranslationKey.role).singular.label}
          value={input.role || null}
          items={Object.keys(SuperUserRole)}
          textBuilder={item => superUserRoleToString(item as SuperUserRole)}
          onSelect={item => setInput(input.withRole(item as SuperUserRole))}
        />
        {(input.role === SuperUserRole.translator || input.role === SuperUserRole.external) && (
          <DropdownMultiSelect
            items={Object.values(TranslationLanguage).filter(language => !input.languages.includes(language))}
            label={t(TranslationKey.language).plural.upper}
            textBuilder={language =>
              LanguageDisplayNames.get(language) || t(TranslationKey.unknownLanguage).singular.upper
            }
            placeholder={t(TranslationKey.selectLanguage).plural.upper}
            values={new Set(input.languages)}
            onSelect={language => setInput(input.withLanguage(language))}
            inputItemBuilder={(language, languageText) => (
              <div className='flex items-center gap-2 rounded-2 border p-1 text-sm'>
                <p>{languageText}</p>
                <Icon type={IconType.x} onClick={() => setInput(input.removeLanguage(language))} size={'size-4'} />
              </div>
            )}
          />
        )}
      </div>
    </ModalPane>
  );
}
